import global from './global/de.json';
import placeholders from './input/placeholders/de.json';
import errors from './input/errors/de.json';
import labels from './input/labels/de.json';
import notifications from './notifications/de.json';
import idle from './idle/de.json';
import start from './start/de.json';
import draw from './draw/de.json';
import invent from './invent/de.json';
import share from './share/de.json';
import share_link from './share-link/de.json';
import share_sms from './share-sms/de.json';
import share_email from './share-email/de.json';
import souvenir from './souvenir/de.json';
import drawing_ready from './drawing-ready/de.json';
import invention_ready from './invention-ready/de.json';
import page_not_found from './page-not-found/de.json';

export default {
  global,
  notifications,
  idle,
  start,
  draw,
  drawing_ready,
  invention_ready,
  invent,
  share,
  share_link,
  share_sms,
  share_email,
  souvenir,
  page_not_found,
  input: {
    labels,
    placeholders,
    errors
  }
};
